<template>
    <main-content>
        <div class="shadow-sm rounded p-4">
            <form @submit.prevent="changeSettings()" id="submit_form">
                <div class="row">
                    <div class="col-12 col-md-6 my-2">
                        <label for="wallet_title" v-text="$t('label.title')"></label>
                        <input class="form-control"
                               id="wallet_title"
                               name="wallet_title"
                               v-model="form_data.wallet_title"
                        >
                    </div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="status" v-text="$t('label.status')"></label>
                        <select class="form-control" id="status" name="status" v-model="form_data.status">
                            <option v-text="walletStatusStr.get(walletStatus.ACTIVE)"
                                    :value="walletStatus.ACTIVE">
                            </option>
                            <option v-text="walletStatusStr.get(walletStatus.INACTIVE)"
                                    :value="walletStatus.INACTIVE">
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="wage_type" v-text="$t('label.wage_type')"></label>
                        <select class="form-control" id="wage_type" name="wage_type" v-model="form_data.wage_type">
                            <option v-for="(item, index) in walletWageType"
                                    :key="index"
                                    v-text="walletWageTypeStr.get(item)"
                                    :value="item"
                            >
                            </option>
                        </select>
                    </div>

                    <div v-if="form_data.wage_type === walletWageType.LIMITED_PERCENT
                                || form_data.wage_type === walletWageType.PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="wage_percent" v-text="$t('label.wage_percent')"></label>
                        <input class="form-control"
                               dir="ltr"
                               id="wage_percent"
                               name="wage_percent"
                               v-model="form_data.wage_percent"
                        >
                    </div>

                    <div v-if="form_data.wage_type === walletWageType.CONSTANT
                                || form_data.wage_type === walletWageType.LIMITED_PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="wage_amount"
                               v-text="form_data.wage_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                        >
                        </label>
                        <input class="form-control"
                               dir="ltr"
                               id="wage_amount"
                               name="wage_amount"
                               v-model="form_data.wage_amount"
                        >
                    </div>

                    <div v-if="form_data.wage_type === walletWageType.LIMITED_PERCENT"
                         class="col-12 col-md-6 my-2">
                        <label for="min_wage_amount" v-text="$t('label.min_wage_amount')"></label>
                        <input class="form-control"
                               dir="ltr"
                               id="min_wage_amount"
                               name="min_wage_amount"
                               v-model="form_data.min_wage_amount"
                        >
                    </div>

                    <div class="col-12 mt-4">
                        <button class="btn btn-success" type="submit" v-text="form_meta_data.submit_btn_text"></button>
                    </div>
                </div>
            </form>
        </div>
    </main-content>
</template>

<script>
    import mainContent from "@/components/main-content";
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {walletStatus, walletStatusStr} from "@/constants/walletStatus";
    import {walletService} from "@/common/api.service";
    import {walletWageType, walletWageTypeStr} from "@/constants/WalletWageType";

    export default {
        components: {
            mainContent,
        },
        data() {
            return {
                walletWageType,
                walletWageTypeStr,
                walletStatus: walletStatus,
                walletStatusStr: walletStatusStr,
                form_data: {
                    wallet_title: '',
                    status: '',
                    wage_type: 1,
                    wage_percent: 0,
                    wage_amount: 0,
                    min_wage_amount: 0,
                },
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('btn.submit_changes'),
                },
            };
        },
        mounted() {
            walletService.find(this.$route.params.hashid).then(res => {
                this.form_data = res.data.data;
            }).catch(err => {
                //
            });
        },
        methods: {
            changeSettings() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        wallet_title: {
                            required: true,
                        },
                        status: {
                            required: true,
                        },
                        wage_type: {
                            required: true,
                        },
                        wage_percent: {
                            required: () => {
                                return this.form_data.wage_type === walletWageType.PERCENT
                                    || this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        wage_amount: {
                            required: () => {
                                return this.form_data.wage_type === walletWageType.CONSTANT
                                    || this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        min_wage_amount: {
                            required: () => {
                                return this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    status: this.form_data.status,
                    wallet_title: this.form_data.wallet_title,
                    wage_type: this.form_data.wage_type,
                    wage_percent: this.form_data.wage_percent,
                    wage_amount: this.form_data.wage_amount,
                    min_wage_amount: this.form_data.min_wage_amount,
                };

                walletService.changeSettingsByAdmin(params, this.$route.params.hashid).then(res => {
                    this.$router.push('/day-wallets/admin');
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }
                    this.showMsg(form, 'danger', response.data.message);
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },
        },
    }
</script>
